var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E8F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0799 22.9515V45.6747H15.9199V22.9515C15.9199 22.2411 16.4911 21.6699 17.2015 21.6699H46.8031C47.5087 21.6747 48.0799 22.2459 48.0799 22.9515Z",
    fill: "#626C78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 23.7578H45.9927V42.7514H18.0039V23.7578Z",
    fill: "#9AC2F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.123 16.3711H42.8814V42.7519H21.123V16.3711Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2012 23.5713H27.3148V27.6849H23.2012V23.5713Z",
    fill: "#1062D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 23.5713H40.7987V24.3729H29.1875V23.5713Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 25.2275H40.7987V26.0291H29.1875V25.2275Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 26.8828H37.0835V27.6844H29.1875V26.8828Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2012 29.9404H27.3148V34.054H23.2012V29.9404Z",
    fill: "#1062D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 29.9404H40.7987V30.742H29.1875V29.9404Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 31.5967H40.7987V32.3983H29.1875V31.5967Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 33.252H37.0835V34.0536H29.1875V33.252Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2012 36.3154H27.3148V40.429H23.2012V36.3154Z",
    fill: "#1062D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 36.3154H40.7987V37.117H29.1875V36.3154Z",
    fill: "#E5E5E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 37.9717H40.7987V38.7733H29.1875V37.9717Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 39.627H37.0835V40.4286H29.1875V39.627Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1999 46.693V45.4066C51.1999 44.8546 50.7535 44.4082 50.2015 44.4082H36.8911V45.4018H27.1039V44.4082H13.8031C13.2511 44.4082 12.8047 44.8546 12.8047 45.4066V46.6882H51.1999V46.693Z",
    fill: "#F7F7F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2008 46.6924C50.3704 47.2972 49.3672 47.6284 48.34 47.6284H15.6664C14.6344 47.6284 13.6312 47.302 12.8008 46.6924H51.2008Z",
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5881_73996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.485 31.1464C38.6374 31.5382 39.4856 34.4772 37.6643 35.3476L33.9352 35.1334C32.1067 34.4504 33.129 31.5382 33.2814 31.1464C33.3287 31.0122 33.4177 30.8966 33.5353 30.8165C33.6529 30.7363 33.793 30.6958 33.9352 30.7009C34.1218 30.3603 34.3955 30.0754 34.7284 29.8753C35.0613 29.6753 35.4413 29.5673 35.8296 29.5624C37.2415 29.5279 38.2789 30.5584 38.4144 31.0073L38.4149 31.0095C38.4426 31.0527 38.4662 31.0986 38.485 31.1464Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7402 36.2568V36.8571L39.9285 37.9119C40.1169 37.9743 40.2779 38.1001 40.3839 38.2678C40.4899 38.4356 40.5343 38.635 40.5097 38.8319L40.192 41.3737C40.1856 41.4256 40.1604 41.4732 40.1212 41.5078C40.0821 41.5424 40.0317 41.5614 39.9794 41.5614H31.7869C31.7346 41.5614 31.6842 41.5424 31.6451 41.5078C31.6059 41.4732 31.5807 41.4256 31.5743 41.3737L31.2566 38.8325C31.232 38.6355 31.2766 38.436 31.3827 38.2682C31.4889 38.1004 31.65 37.9746 31.8386 37.9124L35.0203 36.8629L35.026 36.2568H36.7402Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9285 37.9121L37.5495 37.125L37.5994 38.4525L35.8831 39.0546L34.1668 38.4525L34.2166 37.1281L31.8386 37.9126C31.65 37.9748 31.4889 38.1006 31.3827 38.2684C31.2766 38.4363 31.232 38.6358 31.2566 38.8328L31.5743 41.3741C31.5807 41.4259 31.6059 41.4736 31.6451 41.5081C31.6842 41.5427 31.7347 41.5618 31.7869 41.5618H39.9793C40.0316 41.5618 40.082 41.5427 40.1212 41.5081C40.1603 41.4736 40.1855 41.4259 40.192 41.3741L40.5097 38.8323C40.5343 38.6353 40.4899 38.4359 40.3839 38.2681C40.2779 38.1003 40.117 37.9744 39.9285 37.9121Z",
    fill: "#384B91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8838 38.7522L35.6696 37.8642L34.8125 37.4473L35.8838 38.7522Z",
    fill: "#697F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8828 38.7522L36.0971 37.8642L36.9542 37.4473L35.8828 38.7522Z",
    fill: "#697F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5076 39.7782C37.7564 38.7466 37.5394 37.2932 37.5107 37.1118L37.4511 37.0921L37.3278 37.0512L37.2704 37.0381L35.8832 38.7522L34.496 37.0381L34.4713 37.0437L34.2793 37.1071L34.2552 37.115C34.225 37.3062 34.011 38.7509 34.2588 39.7782C34.4267 40.4508 34.7712 41.0663 35.2565 41.5612H36.5099C36.9952 41.0663 37.3397 40.4508 37.5076 39.7782Z",
    fill: "#C6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6556 33.8483C38.6552 33.6234 38.5665 33.4077 38.4086 33.2477C38.2507 33.0876 38.0362 32.996 37.8114 32.9925V32.9912H37.3828V34.7054H37.8114V34.7041C38.0362 34.7006 38.2507 34.609 38.4086 34.4489C38.5665 34.2888 38.6552 34.0731 38.6556 33.8483Z",
    fill: "#F99F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9547 32.9912C33.7274 32.9912 33.5094 33.0815 33.3487 33.2422C33.188 33.403 33.0977 33.621 33.0977 33.8483C33.0977 34.0756 33.188 34.2936 33.3487 34.4543C33.5094 34.6151 33.7274 34.7054 33.9547 34.7054H34.3833V32.9912H33.9547Z",
    fill: "#F99F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7395 36.684V35.6143H35.0254V36.684C35.5759 36.9023 36.189 36.9023 36.7395 36.684Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9551 32.9907C33.9551 31.689 34.1304 30.6338 35.8835 30.6338C37.6366 30.6338 37.8119 31.689 37.8119 32.9907V34.4906C37.8119 35.0021 37.6087 35.4926 37.2471 35.8542C36.8854 36.2159 36.3949 36.4191 35.8835 36.4191C35.3721 36.4191 34.8815 36.2159 34.5199 35.8542C34.1583 35.4926 33.9551 35.0021 33.9551 34.4906V32.9907Z",
    fill: "#FFAB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4948 30.9277C37.1368 30.5411 36.0867 30.3957 35.2858 30.4858C35.0642 30.4785 34.8445 30.5296 34.6489 30.634C34.5237 30.677 34.4149 30.7576 34.3371 30.8647C34.3157 30.8854 34.2941 30.9051 34.2731 30.9277C33.6992 31.5475 33.9555 32.99 33.9555 32.99C33.9874 32.6924 34.0443 32.398 34.1256 32.11C34.1737 31.9801 34.2649 31.8707 34.384 31.8001C34.6105 31.7327 34.8115 31.599 34.9611 31.4161C35.2378 31.6085 35.5524 31.7395 35.8839 31.8001C36.382 31.8608 36.8857 31.8608 37.3838 31.8001C37.5029 31.8707 37.5942 31.9801 37.6422 32.11C37.7236 32.398 37.7805 32.6924 37.8123 32.99C37.8123 32.99 38.0687 31.5475 37.4948 30.9277Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.073 38.7843L35.6687 37.8642L35.0201 36.8623L34.3027 37.0991L35.073 38.7843Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4649 37.097L36.7405 36.8574L36.0977 37.8649L36.6933 38.785L37.4649 37.097Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5977 37.002L33.4204 37.3903L32.9922 38.2125L33.6527 38.7757L33.3362 39.6005L35.2555 41.5615C34.7372 40.7061 34.4719 38.492 34.5977 37.002Z",
    fill: "#2C58D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1125 38.7752L38.773 38.2121L38.3434 37.3872L37.1672 36.998C37.2938 38.4882 37.0285 40.705 36.5098 41.5611L38.4291 39.6L38.1125 38.7752Z",
    fill: "#2C58D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5881_73996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(30 29.5615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLog);
export default __webpack_public_path__ + "static/media/userLog.c61bdcec479fe9432158524c5a6e44e1.svg";
export { ForwardRef as ReactComponent };